import React, { ReactNode, FC } from 'react'
import styles from './Fallback.module.scss'
import Search from './Search/Search'
import { submitSearch } from 'components/Header/Main/helpers'
import HeaderSection from './Header/HeaderSection'

type Props = {
  title?: string
  subTitle?: string
  description?: string
  customTitleStyle?: string
}

const Fallback: FC<React.PropsWithChildren<Props>> = ({
  title,
  subTitle,
  description,
  children,
  customTitleStyle = '',
}) => {
  return (
    <div className={styles.fallback}>
      <div className={styles.topSection}>
        <HeaderSection
          title={title}
          subTitle={subTitle}
          description={description}
          customTitleStyle={customTitleStyle}
        />
        <Search onSearch={submitSearch} />
        <a
          className={styles.contactUsLink}
          href='https://support.saatchiart.com/hc/en-us/requests/new'
          title='Contact Support'
          target='_blank'
          rel='noopener noreferrer'
        >
          Contact Support
        </a>
      </div>
      {children}
    </div>
  )
}

export default Fallback
